<div *ngIf="data" class="container-sm">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-8 col-lg-6 medium-teasers">
      <div *ngFor="let item of data.teasersMedium" class="card-item-wrapper">
        <mb-card
          (click)="openCardMedia(item)"
          [data]="item"
          [actions]="item.actions"
          [layouts]="mediumLayouts"
          alignContent="top"
        >
          <figure>
            <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 large-teaser">
      <div class="card-item-wrapper">
        <mb-card
          (click)="openCardMedia(data.teaserLarge)"
          [data]="data.teaserLarge"
          [actions]="data.teaserLarge.actions"
          [layout]="CardCollayout"
          alignContent="top"
        >
          <figure>
            <mb-media [media]="data.teaserLarge.media" [hoverplay]="true"></mb-media>
          </figure>
        </mb-card>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-12 col-lg-3 col-sm-6 small-teasers">
      <div *ngFor="let item of data.teasersSmall" class="card-item-wrapper">
        <mb-card [data]="item" [layout]="CardCollayout" alignContent="top"></mb-card>
      </div>
    </div>
  </div>
</div>
